import React from "react";

const AcceptableUsePolicy = () => {
  return (
    <div className="w-3/4 bg-[#04152d] p-4 text-white leading-8">
      <h2 className="text-[32px] font-bold mb-4">ACCEPTABLE USE POLICY</h2>
      <br></br>
      <h3 className="font-semibold text-xl">Introduction </h3>
      <br></br>
      These terms and conditions apply between you, the User of this Website
      (including any sub-domains, unless expressly excluded by their own terms
      and conditions), and Atendi Ltd, the owner and operator of this Website.
      Please read these terms and conditions carefully, as they affect your
      legal rights. Your agreement to comply with and be bound by these terms
      and conditions is deemed to occur upon your first use of the Website. If
      you do not agree to be bound by these terms and conditions, you should
      stop using the Website immediately. <br></br>
      In these terms and conditions, User or Users means any third party that
      accesses the Website and is not either<br></br> (i) employed by Atendi Ltd
      and acting in the course of their employment or <br></br> (ii) engaged as
      a consultant or otherwise providing services to Atendi Ltd and accessing
      the Website in connection with the provision of such services.
      <br></br>
      You must be at least 18 years of age to use this Website. By using the
      Website and agreeing to these terms and conditions, you represent and
      warrant that you are at least 18 years of age.
      <br /> <br></br>
      <h3 className="font-semibold text-xl">Acceptable Use </h3>
      <br></br>
      1. All Content included on the Website, unless uploaded by Users, is the
      property of Atendi Ltd, our affiliates or other relevant third parties. In
      these terms and conditions, Content means any text, graphics, images,
      audio, video, software, data compilations, page layout, underlying code
      and software and any other form of information capable of being stored in
      a computer that appears on or forms part of this Website, including any
      such content uploaded by Users. By continuing to use the Website you
      acknowledge that such Content is protected by copyright, trademarks,
      database rights and other intellectual property rights. Nothing on this
      site shall be construed as granting, by implication, estoppel, or
      otherwise, any license or right to use any trademark, logo or service mark
      displayed on the site without the owner's prior written permission
      <br></br>
      2. You may, for your own personal, non-commercial use only, do the
      following:
      <br></br>
      a. retrieve, display and view the Content on a device
      <br></br>
      b. print one copy of the Content
      <br></br>
      3. You must not otherwise reproduce, modify, copy, distribute or use for
      commercial purposes any Content without the written permission of Atendi
      Ltd.
      <br></br>
      <br></br>
      <h3 className="font-semibold text-xl">Prohibited Use </h3>
      <br></br>
      4. You may not use the Website for any of the following purposes:
      <br></br>
      a. in any way which causes, or may cause, damage to the Website or
      interferes with any other person's use or enjoyment of the Website;
      <br></br>
      b. in any way which is harmful, unlawful, illegal, abusive, harassing,
      threatening or otherwise objectionable or in breach of any applicable law,
      regulation, governmental order;
      <br></br>
      c. making, transmitting or storing electronic copies of Content protected
      by copyright without the permission of the owner.
      <br></br>
      <br></br>
      <h3 className="font-semibold text-xl">Registration </h3>
      <br></br>
      5. You must ensure that the details provided by you on registration or at
      any time are correct and complete.
      <br></br>
      6. You must inform us immediately of any changes to the information that
      you provide when registering by updating your personal details to ensure
      we can communicate with you effectively.
      <br></br>
      7. We may suspend or cancel your registration with immediate effect for
      any reasonable purposes or if you breach these terms and conditions.
      <br></br>
      8. You may cancel your registration at any time by informing us in writing
      to the address at the end of these terms and conditions. If you do so, you
      must immediately stop using the Website. Cancellation or suspension of
      your registration does not affect any statutory rights.
      <br></br>
      <br></br>
      <h3 className="font-semibold text-xl">Links to Other Websites </h3>
      <br></br>
      9. This Website may contain links to other sites. Unless expressly stated,
      these sites are not under the control of Atendi Ltd or that of our
      affiliates.
      <br></br>
      10. We assume no responsibility for the content of such Websites and
      disclaim liability for any and all forms of loss or damage arising out of
      the use of them.
      <br></br>
      11. The inclusion of a link to another site on this Website does not imply
      any endorsement of the sites themselves or of those in control of them.
      <br></br>
      <br></br>
      <h3 className="font-semibold text-xl">
        Availability of the Website and Disclaimers
      </h3>
      <br></br>
      12. Any online facilities, tools, services or information that Atendi Ltd
      makes available through the Website (the Service) is provided "as is" and
      on an "as available" basis. We give no warranty that the Service will be
      free of defects and/or faults. To the maximum extent permitted by the law,
      we provide no warranties (express or implied) of fitness for a particular
      purpose, accuracy of information, compatibility and satisfactory quality.
      Atendi Ltd is under no obligation to update information on the Website.
      <br></br>
      13. Whilst Atendi Ltd uses reasonable endeavours to ensure that the
      Website is secure and free of errors, viruses and other malware, we give
      no warranty or guaranty in that regard and all Users take responsibility
      for their own security, that of their personal details and their
      computers.
      <br></br>
      14. Atendi Ltd accepts no liability for any disruption or non-availability
      of the Website.
      <br></br>
      15. Atendi Ltd reserves the right to alter, suspend or discontinue any
      part (or the whole) of the Website including, but not limited to, any
      products and/or services available. These terms and conditions shall
      continue to apply to any modified version of the Website unless it is
      expressly stated otherwise.
      <br></br>
      <br></br>
      <h3 className="font-semibold text-xl">Limitation of Liability</h3>
      <br></br>
      17. Nothing in these terms and conditions will: (a) limit or exclude our
      or your liability for death or personal injury resulting from our or your
      negligence, as applicable; (b) limit or exclude our or your liability for
      fraud or fraudulent misrepresentation; or (c) limit or exclude any of our
      or your liabilities in any way that is not permitted under applicable law.
      <br></br>
      18. To the extent that the Website and Content are provided free of
      charge, we will not be liable to you for any loss or damage of any kind.
      <br></br>
      19. We will not be liable to you in respect of any losses arising out of
      events beyond our reasonable control.
      <br></br>
      20. To the maximum extent permitted by law, Atendi Ltd accepts no
      liability for any of the following:
      <br></br>
      a. any business losses, such as loss of profits, income, revenue,
      anticipated savings, business, contracts, goodwill or commercial
      opportunities;
      <br></br>
      b. loss or corruption of any data, database or software;
      <br></br>
      c. any special, indirect or consequential loss or damage.
      <br></br>
      <h3 className="font-semibold text-xl">Limitation of Liability</h3>
      <br></br>
      21. You may not transfer any of your rights under these terms and
      conditions to any other person. We may transfer our rights under these
      terms and conditions where we reasonably believe your rights will not be
      affected.
      <br></br>
      22. These terms and conditions may be varied by us from time to time. Such
      revised terms will apply to the Website from the date of publication.
      Users should check the terms and conditions regularly to ensure
      familiarity with the then current version.
      <br></br>
      23. These terms and conditions , together with the Privacy Policy and
      Cookies Policy, contain the whole agreement between the parties relating
      to its subject matter and supersede all prior discussions, arrangements or
      agreements that might have taken place in relation to the terms and
      conditions.
      <br></br>
      24. The Contracts (Rights of Third Parties) Act 1999 shall not apply to
      these terms and conditions and no third party will have any right to
      enforce or rely on any provision of these terms and conditions.
      <br></br>
      25. If any court or competent authority finds that any provision of these
      terms and conditions (or part of any provision) is invalid, illegal or
      unenforceable, that provision or part-provision will, to the extent
      required, be deemed to be deleted, and the validity and enforceability of
      the other provisions of these terms and conditions will not be affected.
      <br></br>
      26. Unless otherwise agreed, no delay, act or omission by a party in
      exercising any right or remedy will be deemed a waiver of that, or any
      other, right or remedy.
      <br></br>
      27. This Agreement shall be governed by and interpreted according to the
      law of England and Wales and all disputes arising under the Agreement
      (including non-contractual disputes or claims) shall be subject to the
      exclusive jurisdiction of the English and Welsh courts.
      <br></br>
      <br></br>
      <h3 className="font-semibold text-xl"> Atendi Ltd Details</h3>
      <br></br>
      28. Atendi Ltd is a company incorporated in with registered number
      14185160 whose registered address is 150 Midsummer Boulevard, Milton
      Keynes, MK9 1FD and it operates the Website www.motickets.ng. You can
      contact Atendi Ltd by email on help@motickets.ng.
    </div>
  );
};

export default AcceptableUsePolicy;
